module.exports = __webpack_public_path__ + "img/guidePage1.564fc654.png";